export const LOAD_AGE_RESTRICTIONS = 'load_age_restrictions';
export const AGE_RESTRICTIONS_LOADED = 'age_restriction_loaded';
export const LOAD_AGE_RESTRICTION = 'load_age_restriction';
export const AGE_RESTRICTION_LOADED = 'age_restriction_loaded';
export const AGE_RESTRICTION_DELETED = 'age_restriction_age_restriction_deleted';
export const RESET_AGE_RESTRICTIONS = 'reset_age_restrictions';
export const RESET_AGE_RESTRICTION = 'reset_age_restriction';
export const SYNC_FAILED = 'age_restriction_sync_has_failed';
export const SAVE_AGE_RESTRICTION = 'save_age_restriction';
export const AGE_RESTRICTIONS_SAVED = 'age_restrictions_saved';
export const AGE_RESTRICTION_ADDED = 'age_restriction_added';
